// src/apiConfig.js

const API_URL = (
  process.env.REACT_APP_API_URL ||
  `http://${window.location.hostname}:4000`
).replace(/\/$/, "");

export default API_URL;